// extracted by mini-css-extract-plugin
export default {"card":"account-locations_card__o8em+","cardTitle":"account-locations_cardTitle__mhEGl"};